var map = {
	"./angular.png": 18,
	"./azure.png": 19,
	"./c#.png": 20,
	"./css3.png": 21,
	"./firebase.png": 22,
	"./java.png": 23,
	"./javascript.png": 24,
	"./node.png": 25,
	"./npm.png": 26,
	"./python.png": 27,
	"./react.png": 28,
	"./sass.png": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;